
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ReadMore',
  props: {
    longText: String,
    isMobile: Boolean
  },
  data() {
    return {
      readMoreActivated: false
    }
  },
  methods: {
    truncateText(originalText: string) : any
    {
      // Skip truncation if mobile
      if(this.isMobile) {
        this.readMoreActivated = true;
        return;
      }

      // Split the original text into an array of words
      const words = originalText.split(',');
      const maxWords = 10;

      // Check if the number of words in the text is greater than the maximum
      if (words.length > maxWords) {
        // If yes, truncate the array and join it back into a string
        return words.slice(0, maxWords).join(',') + ', ';
      } else {
        this.readMoreActivated = true;
      }
    },
    activateReadMore(e: Event)
    {
      e.preventDefault();
      this.readMoreActivated = true;
    },
  }
});
